export default "__VITE_ASSET__f7a252ce__"